module.exports = __webpack_public_path__ + "portal-static/img/1首页--1实验用房使用排行_36.dd306413.jpg";